import { Layout } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import CustomNotification from './CustomNotification';
import Menu from './Menu';
// import AppBar from './AppBar';

const useStyles = makeStyles({
  root: { boxSizing: 'border-box', maxWidth: '100%', minWidth: 0, width: '100%' },
  appFrame: { boxSizing: 'border-box', maxWidth: '100%', minWidth: 0, width: '100%' },
  contentWithSidebar: { boxSizing: 'border-box', maxWidth: '100%', minWidth: 0, overflow: 'hidden', width: '100%' },
  content: { boxSizing: 'border-box', maxWidth: '100%', minWidth: 0, overflow: 'hidden' },
});

const AppLayout = props => {
  const classes = useStyles();
  return <Layout {...props} classes={{ ...classes, ...props.classes }} menu={Menu} notification={CustomNotification} />;
};

export default AppLayout;
